export default __webpack_public_path__ + "static/media/progress.92ce4c9a.png";